import React from "react";

import "./index.scss";
import PrimaryButton from "../../components/PrimaryButton";

function ErrorWrapper({ error, componentStack }) {
  return (
    <div className="error-wrapper">
      <div className="error-body">
        <p className="error-heading">Something went wrong:</p> {error.message}
      </div>

      <PrimaryButton
        label={"Try Again"}
        onClick={() => document.location.reload()}
      />
    </div>
  );
}

export default ErrorWrapper;
